<template>
  <div>
    <list
      row-key="index"
      ref="list"
      unit="销货单统计表"
      :is-dialog-query="isDialogQuery"
      :expand-all-row="true"
      :page="true"
      :show-checkbox="false"
      :show-query="true"
      :query-params="params"
      :get-data-func="getDataFunc"
      @closeDialog="closed"
      isIfShow
      :page-size="10"
      show-summary
      :summary-method="summaryMethod"
      :ifShow="ifShow"
      :other-list="zkfs==1?'':'2'"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" @click="onPrint">打印</el-button>
        <el-button type="success" @click="onExport">导出</el-button>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
const arr = ["单据总金额","核销金额","余额"]
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import Bus from "@/utils/bus";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    //是否弹窗查询
    isDialogQuery: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/rp/outwriteoff").default,
      params: {
        
      },
      zkfs: 1,
      ifShow: {
        query: [{
          key: 'zkfs',
          values: [1]
        }],
        lists: ['SrcVouTypeName', 'WriteoffDate', 'WriteoffNo', 'NeedAmount']
      }
    };
  },
  activated() {
    if (this.$refs.list.isSetQuery === false) {
      this.getData();
    }
  },
  mounted() {
    Bus.$on("closeTag", (route) => {
      console.log("route.fullPath 应付核销情况表", route.fullPath);
      console.log("this.$route.fullPath 应付核销情况表", this.$route.fullPath);

      if (route.fullPath === "/finance/dealings/outwriteoff") {
        this.$refs.list.data = [];
        this.$refs.list.isSetQuery = false;
      }
    });
  },
  methods: {
    getDataFunc(params) {
      this.zkfs = params.zkfs;
      var name = params.zkfs==1?"getRpChkPayWriteOff":"getRpPayWriteOff";
      var str = JSON.stringify(params);
      var sub = JSON.parse(str);
      if(params.zkfs == 2) {
        sub.DocType = params.SrcVouType;
        sub.SrcVouDateStart = params.DocDateStart;
        sub.SrcVouDateEnd = params.DocDateEnd;
        delete sub.SrcVouType;
        delete sub.DocDateStart;
        delete sub.DocDateEnd;
      }
      var sub2 = params.zkfs==1?params:sub;
      var final = {};
      for(var key in sub2) {
        if(!(typeof(sub2[key]) == "object" && sub2[key].length==0)) {
          final[key] = sub2[key];
        }
      }
      return new Promise((resolve,reject) => {
        this.api[name](final).then(res => {
          if(res.Data) {
            res.Data.forEach((e,index) => {
              e.index = index;
            })
          }
          resolve(res);
        })
      })
    },
    closed(isSetQuery) {
      if (!isSetQuery) {
        this.closeSelectedTag(this.$route);
      }
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === "index") {
          // to reload home page
          this.$router.replace({ path: view.fullPath });
        } else {
          this.$router.push("/");
        }
      }
    },
    closeSelectedTag(view) {
      this.$store.dispatch("delView", view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view);
        }
      });
    },
    summaryMethod(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        } else if(arr.indexOf(column.label) > -1) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr*100;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = Math.floor(sums[index])/100;
          } else {
            sums[index] = '-';
          }
        } else {
          sums[index] = "-"
        }
      });
      return sums;
    },
    // delRange(ids) {
    //   this.api.delete({ ids }).then((res) => {
    //     if (res.Code == 0) {
    //       this.$message.success("删除成功");
    //       this.reload();
    //     } else {
    //       this.$message.error(res.Msg);
    //     }
    //   });
    // },
    onPrint() {
      var list = this.$refs.list;
      var listParams = list.tempQueryParams;
      var fields = list.tableList.map((x) => x.tableName);
      var params = { ...listParams, Fields: fields.join(",") };
      var data = {
        Params: params,
        TableNames: list.tableList,
        ParamsData: list.paramsData,
      };
      sessionStorage.setItem("outwriteoff_print", JSON.stringify(data));

      var origin = location.origin;
      window.open(origin + "/#/finance/dealings/outwriteoff/print");
    },
    onExport() {
      var list = this.$refs.list;
      var listParams = list.tempQueryParams;
      var fields = list.tableList.map((x) => x.tableName);
      var params = { ...listParams, Fields: fields.join(",") };
      var name = params.zkfs==1?"getRpChkPayWriteOffExport":"getRpPayWriteOffExport";
      // console.log('onExport', params);
      var str = JSON.stringify(params);
      var sub = JSON.parse(str);
      if(params.zkfs == 2) {
        sub.DocType = params.SrcVouType;
        sub.SrcVouDateStart = params.DocDateStart;
        sub.SrcVouDateEnd = params.DocDateEnd;
        delete sub.SrcVouType;
        delete sub.DocDateStart;
        delete sub.DocDateEnd;
      }
      var sub2 = params.zkfs==1?params:sub;
      var final = {};
      for(var key in sub2) {
        if(!(typeof(sub2[key]) == "object" && sub2[key].length==0)) {
          final[key] = sub2[key];
        }
      }
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api[name](final).then((res) => {
        loading.close();
      });
    },
  },
};
</script>
